export default "__VITE_ASSET__uIUHhTr$__"